import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd-multi-backend";
import "../App.css";
import { DraggableMessage } from "../components/Draggables";
import {
  FONT,
  MAYA_SYSTEM,
  REGEX_VALID_DECIMAL
} from "../defaults";
import { convertToAlternate, increaseProgress, RenderMayaImages } from "../helpers";
import {
  buttonCheck,
  level0MayaTask,
  levelCorrect,
  levelIncorrect,
  levelNoInput
} from "../strings";

const LevelNumber = 0;

function generateNumber(currentProgress) {
  const numbers = [2, 8, 14];
  if (currentProgress >= numbers.length) {
    return Math.round(Math.random() * 18) + 1; // Generate integer between 1 and 19.
  }
  return numbers[currentProgress];
}

/* Partially LLM-generated. */
const taskStyle = {
  display: "flex", 
  justifyContent: "center", 
  alignItems: "center", 
  fontFamily: FONT, 
  fontSize: "5dvh",
  position: "absolute", // Fix the position of the container
  top: "50%", // Start the container at the center of the parent
  left: "50%", // Center it horizontally in the parent
  transform: "translate(-50%, -50%)", // Adjust the position to truly center it
}

const inputStyle = {
  fontFamily: FONT,
  fontSize: "5dvh", 
  maxWidth: "15dvh"
};

const headerStyle = {
  marginTop: "4dvh",
  padding: "0 3dvh",
  fontFamily: FONT,
  fontSize: "4dvh",
  textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
};

function Level0Maya({levelProgress, setLevelProgress, showMessage, setShowMessage, disableInput, setDisableInput}) {
  const [number, setNumber] = useState(
    generateNumber(levelProgress[LevelNumber])
  );
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [correct, setCorrect] = useState(false);

  useEffect(() => {
    setNumber(generateNumber(levelProgress[LevelNumber]));
    setInput("");
  }, [levelProgress]);

  const checkAnswers = () => {
    const isCorrect = (input === number.toString());
    setCorrect(isCorrect);
    if (isCorrect) {
      setMessage(levelCorrect)
    } else if (input === "") {
      setMessage(levelNoInput);
    } else {
      setMessage(levelIncorrect);
    }
    displayMessage();
  };

  const displayMessage = () => {
    setDisableInput(true);
    setShowMessage(true);
  };

  const handleCloseMessage = () => {
    if (correct) {
      increaseProgress(levelProgress, setLevelProgress, LevelNumber, MAYA_SYSTEM);
    }
    if (input !== "") {
      setInput("");
    }
    setMessage("");
    setDisableInput(false);
    setCorrect(false);
  };

  return (
    <div>
      <div style={headerStyle}>
        {level0MayaTask}
      </div>
      <DndProvider options={HTML5toTouch}>
        {showMessage && <DraggableMessage show={showMessage} setShow={setShowMessage} handleClose={handleCloseMessage} message={message}/>} {/* Conditionally rendering it with showMessage makes the message re-render, and hence center itself, every time. */}
        <div style={taskStyle}>
          <RenderMayaImages droppedItems={convertToAlternate(MAYA_SYSTEM, number)} itemSize={10}/>
          <span style={{margin: "0 2dvh", textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",}}>=</span>
          <input
            className="input-field"
            style={inputStyle}
            type="text"
            inputMode="numeric"
            value={input}
            maxLength={5}
            disabled={disableInput}
            placeholder=""
            pattern={REGEX_VALID_DECIMAL}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\s/g, ''); // LLM-generated. Disallow white-space input.
              setInput(e.target.value)}
            }
          />
        </div>
      </DndProvider>
      <button className="checkAnswer-button" onClick={checkAnswers} disabled={disableInput}>
          {buttonCheck}
      </button>
    </div>
  );
}

export default Level0Maya;
